import Page from '../../classes/Page';
import createServiceStickyButton from './stickyButton';

const servicePage = new Page({
	onInit() {
		createServiceStickyButton()
	},
	name: 'service',
	rootElementId: 'js-service-page',
});

export default servicePage;
